export default __webpack_public_path__ + "static/media/PH-A586.1326d06b.webp";